import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["textContent"]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountDown',
  props: {
  value: {
    value: [String, Number],
    required: true,
  },
  title: {
    type: String,
  },
},
  setup(__props) {

const props = __props;



const numericValue = computed<number>(() => {
  const value = props.value as string | number;
  return typeof value === 'number'
    ? value
    : parseFloat(value.replace(/^\D\s/, ''));
});
const isPositive = computed<boolean>(() => {
  return numericValue.value > 0;
});
const isNeutral = computed<boolean>(() => {
  return numericValue.value === 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "countdown",
    title: props.title
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["countdown__value", {
        'countdown__value--neutral': _unref(isNeutral),
        'countdown__value--negative': !_unref(isPositive),
        'countdown__value--positive': _unref(isPositive),
      }]),
      textContent: _toDisplayString(props.value)
    }, null, 10, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})